export default {
    '.refinement-sort-section': {
        top: '-30px', // Header is thinner than sticky bar. Must use negative top to hide it.
        position: 'sticky',
        zIndex: 2,
        background: 'var(--chakra-colors-white)',
        transition: 'top 0.3s ease',
        '.product-list-sort, .radio-button': {
            color: 'var(--chakra-colors-black)'
        }
    },

    '.refinements-modal': {
        '.product-list-sort, .radio-button': {
            color: 'var(--chakra-colors-black-100)'
        }
    },
    '.sticky-section-desktop': {
        top: '60px'
    },
    '.sticky-section-desktop, .sticky-section-mobile': {
        position: 'sticky',
        boxShadow: '0 3px 5px 0 rgba(0,0,0,.15)'
    },

    '.sticky-section-mobile': {
        top: '57px !important'
    },

    '.modal-filters': {
        msOverflowStyle: 'none', // Internet Explorer 10+
        scrollbarWidth: 'none', // Firefox

        '&::-webkit-scrollbar': {
            display: 'none' // Safari and Chrome
        }
    }
}
